let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fejHU")).then(() => parcelRequire('5GcYI'));